import React, { useState } from 'react';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [selectedDay, setSelectedDay] = useState('today');

  const mealData = {
    breakfast: 45,
    lunch: 78,
    hiTea: 32,
    dinner: 65
  };

  const qrScanData = {
    admin: 125,
    player: 340
  };

  const scanHistory = [
    { id: 1, adminName: 'John Smith', date: '2025-10-28', time: '09:30 AM' },
    { id: 2, adminName: 'Sarah Johnson', date: '2025-10-28', time: '10:15 AM' },
    { id: 3, adminName: 'Mike Wilson', date: '2025-10-28', time: '11:45 AM' },
    { id: 4, adminName: 'Emily Davis', date: '2025-10-28', time: '01:20 PM' },
    { id: 5, adminName: 'John Smith', date: '2025-10-28', time: '02:30 PM' },
    { id: 6, adminName: 'Robert Brown', date: '2025-10-28', time: '03:15 PM' },
    { id: 7, adminName: 'Lisa Anderson', date: '2025-10-28', time: '04:00 PM' },
    { id: 8, adminName: 'Sarah Johnson', date: '2025-10-28', time: '05:30 PM' },
  ];

  const handleDayChange = (e) => {
    setSelectedDay(e.target.value);
  };

  const maxMeal = Math.max(...Object.values(mealData));
  const maxQr = Math.max(qrScanData.admin, qrScanData.player);
  const totalMeals = Object.values(mealData).reduce((a, b) => a + b, 0);

  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('');
  };

  const mealPercentage = (value) => {
    return ((value / totalMeals) * 100).toFixed(1);
  };

  return (
    <div className="modern-dashboard-wrapper">
      {/* Animated Header with Gradient */}
      <div className="modern-header-gradient">
        <div className="modern-header-bg-animation"></div>
        <div className="modern-header-content">
          <div className="modern-header-title-wrapper">
            <h1 className="modern-header-title">Admin Dashboard</h1>
          </div>
        </div>
      </div>

      <div className="modern-main-content">
        {/* Stats Cards with Animation */}
        <div className="modern-stats-grid">
          <div className="modern-stat-card modern-stat-card-pulse">
            <div className="modern-stat-glow modern-stat-glow-purple"></div>
            <div className="modern-stat-content">
              <div className="modern-stat-info">
                <p className="modern-stat-label">Total Players</p>
                <p className="modern-stat-number modern-stat-number-purple">1,234</p>
              </div>
              <div className="modern-stat-icon-box modern-icon-box-purple">
                <div className="modern-icon-pulse"></div>
                <svg className="modern-stat-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
            </div>
          </div>

          <div className="modern-stat-card modern-stat-card-pulse">
            <div className="modern-stat-glow modern-stat-glow-blue"></div>
            <div className="modern-stat-content">
              <div className="modern-stat-info">
                <p className="modern-stat-label">Total Tournaments</p>
                <p className="modern-stat-number modern-stat-number-blue">24</p>
              </div>
              <div className="modern-stat-icon-box modern-icon-box-blue">
                <div className="modern-icon-pulse"></div>
                <svg className="modern-stat-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
            </div>
          </div>

          <div className="modern-stat-card modern-stat-card-pulse">
            <div className="modern-stat-glow modern-stat-glow-green"></div>
            <div className="modern-stat-content">
              <div className="modern-stat-info">
                <p className="modern-stat-label">Active Tournaments</p>
                <p className="modern-stat-number modern-stat-number-green">8</p>
              </div>
              <div className="modern-stat-icon-box modern-icon-box-green">
                <div className="modern-icon-pulse"></div>
                <svg className="modern-stat-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
            </div>
          </div>

          <div className="modern-stat-card modern-stat-card-pulse">
            <div className="modern-stat-glow modern-stat-glow-orange"></div>
            <div className="modern-stat-content">
              <div className="modern-stat-info">
                <p className="modern-stat-label">Completed Tournaments</p>
                <p className="modern-stat-number modern-stat-number-orange">16</p>
              </div>
              <div className="modern-stat-icon-box modern-icon-box-orange">
                <div className="modern-icon-pulse"></div>
                <svg className="modern-stat-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Day Selector */}
        <div className="modern-day-selector">
          <div className="modern-selector-inner">
            <label htmlFor="modern-day-select" className="modern-day-label">
              <svg className="modern-label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Select Day:
            </label>
            <select 
              id="modern-day-select" 
              value={selectedDay} 
              onChange={handleDayChange}
              className="modern-day-dropdown"
            >
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="2025-10-26">October 26, 2025</option>
              <option value="2025-10-25">October 25, 2025</option>
              <option value="2025-10-24">October 24, 2025</option>
            </select>
          </div>
        </div>

        {/* Charts Section with Modern Design */}
        <div className="modern-charts-grid">
          {/* Meal Distribution - Donut Chart Style */}
          <div className="modern-chart-card">
            <div className="modern-chart-header">
              <div className="modern-chart-icon-wrapper modern-chart-icon-meals">
                <svg className="modern-chart-header-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <div>
                <h3 className="modern-chart-title">Meal Distribution</h3>
                <p className="modern-chart-subtitle">{totalMeals} total meals served</p>
              </div>
            </div>
            
            <div className="modern-donut-chart-wrapper">
              <div className="modern-donut-chart">
                {Object.entries(mealData).map(([key, value], index) => {
                  const colors = {
                    breakfast: '#9AE3F0',
                    lunch: '#48CAE4',
                    hiTea: '#00B4D8',
                    dinner: '#0096C7'
                  };
                  return (
                    <div key={key} className={`modern-donut-segment modern-donut-${key}`} style={{animationDelay: `${index * 0.1}s`}}>
                      <div className="modern-donut-value">{value}</div>
                      <div className="modern-donut-bar" style={{height: `${(value / maxMeal) * 100}%`, backgroundColor: colors[key]}}></div>
                    </div>
                  );
                })}
              </div>
              <div className="modern-meal-legend">
                <div className="modern-legend-item">
                  <div className="modern-legend-dot modern-dot-breakfast"></div>
                  <span className="modern-legend-label">Breakfast</span>
                  <span className="modern-legend-value">{mealPercentage(mealData.breakfast)}%</span>
                </div>
                <div className="modern-legend-item">
                  <div className="modern-legend-dot modern-dot-lunch"></div>
                  <span className="modern-legend-label">Lunch</span>
                  <span className="modern-legend-value">{mealPercentage(mealData.lunch)}%</span>
                </div>
                <div className="modern-legend-item">
                  <div className="modern-legend-dot modern-dot-hitea"></div>
                  <span className="modern-legend-label">Hi-Tea</span>
                  <span className="modern-legend-value">{mealPercentage(mealData.hiTea)}%</span>
                </div>
                <div className="modern-legend-item">
                  <div className="modern-legend-dot modern-dot-dinner"></div>
                  <span className="modern-legend-label">Dinner</span>
                  <span className="modern-legend-value">{mealPercentage(mealData.dinner)}%</span>
                </div>
              </div>
            </div>
          </div>

          {/* QR Scanning - Modern Progress Bars */}
          <div className="modern-chart-card">
            <div className="modern-chart-header">
              <div className="modern-chart-icon-wrapper modern-chart-icon-qr">
                <svg className="modern-chart-header-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                </svg>
              </div>
              <div>
                <h3 className="modern-chart-title">QR Scan Analytics</h3>
                <p className="modern-chart-subtitle">{qrScanData.admin + qrScanData.player} total scans</p>
              </div>
            </div>
            
            <div className="modern-progress-chart">
              <div className="modern-progress-item">
                <div className="modern-progress-header">
                  <div className="modern-progress-label-box">
                    <div className="modern-progress-icon modern-progress-icon-admin">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                    </div>
                    <span className="modern-progress-label">Admin Scans</span>
                  </div>
                  <span className="modern-progress-value">{qrScanData.admin}</span>
                </div>
                <div className="modern-progress-bar-container">
                  <div 
                    className="modern-progress-bar modern-progress-bar-admin" 
                    style={{width: `${(qrScanData.admin / maxQr) * 100}%`}}
                  >
                    <div className="modern-progress-shimmer"></div>
                  </div>
                </div>
                <div className="modern-progress-percentage">{((qrScanData.admin / (qrScanData.admin + qrScanData.player)) * 100).toFixed(1)}% of total</div>
              </div>

              <div className="modern-progress-item">
                <div className="modern-progress-header">
                  <div className="modern-progress-label-box">
                    <div className="modern-progress-icon modern-progress-icon-player">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                    <span className="modern-progress-label">Player Scans</span>
                  </div>
                  <span className="modern-progress-value">{qrScanData.player}</span>
                </div>
                <div className="modern-progress-bar-container">
                  <div 
                    className="modern-progress-bar modern-progress-bar-player" 
                    style={{width: `${(qrScanData.player / maxQr) * 100}%`}}
                  >
                    <div className="modern-progress-shimmer"></div>
                  </div>
                </div>
                <div className="modern-progress-percentage">{((qrScanData.player / (qrScanData.admin + qrScanData.player)) * 100).toFixed(1)}% of total</div>
              </div>
            </div>
          </div>
        </div>

        {/* Scan History Table */}
        <div className="modern-history-section">
          <div className="modern-history-header">
            <h3 className="modern-history-title">Recent Scan Activity</h3>
          </div>
          <div className="modern-table-wrapper">
            <table className="modern-scan-table">
              <thead>
                <tr>
                  <th>Admin Name</th>
                  <th>Date</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {scanHistory.map((scan, index) => (
                  <tr key={scan.id} style={{animationDelay: `${index * 0.05}s`}}>
                    <td>
                      <div className="modern-admin-cell">
                        <div className="modern-admin-avatar" style={{animationDelay: `${index * 0.1}s`}}>
                          {getInitials(scan.adminName)}
                        </div>
                        <span className="modern-admin-name">{scan.adminName}</span>
                      </div>
                    </td>
                    <td className="modern-table-date">{scan.date}</td>
                    <td className="modern-table-time">{scan.time}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;